import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5137491c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "¿Necesitas ayuda?", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_menu_button = _resolveComponent("ion-menu-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_GalidanciaHomeLogo = _resolveComponent("GalidanciaHomeLogo")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_SidebarMenu = _resolveComponent("SidebarMenu")!
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_tab_button = _resolveComponent("ion-tab-button")!
  const _component_ion_tab_bar = _resolveComponent("ion-tab-bar")!
  const _component_ion_tabs = _resolveComponent("ion-tabs")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      ($setup.showTabsNavigation)
        ? (_openBlock(), _createBlock(_component_ion_header, {
            key: 0,
            ref: "tabsHeaderRef",
            translucent: false,
            class: "galidancia-tabs-header"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  ($setup.estaAutenticado && $setup.showTabsNavigation)
                    ? (_openBlock(), _createBlock(_component_ion_buttons, {
                        key: 0,
                        slot: "start"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_menu_button, { color: "primary" })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ion_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$route.name), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_GalidanciaHomeLogo, { slot: "end" })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512))
        : _createCommentVNode("", true),
      _createVNode(_component_ion_tabs, {
        ref: "tabsElRef",
        class: _normalizeClass({ 'galidancia-tabs-below-header': $setup.showTabsNavigation })
      }, {
        default: _withCtx(() => [
          ($setup.estaAutenticado && $setup.showTabsNavigation)
            ? (_openBlock(), _createBlock(_component_SidebarMenu, { key: 0 }))
            : _createCommentVNode("", true),
          _createVNode(_component_ion_router_outlet, { id: "main-content" }),
          ($setup.estaAutenticado && $setup.showTabBar)
            ? (_openBlock(), _createBlock(_component_ion_tab_bar, {
                key: 1,
                ref: "tabBarRef",
                slot: "bottom",
                class: "galidancia-tab-bar"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_tab_button, {
                    layout: "icon-top",
                    tab: "clases",
                    href: "/tabs/clases",
                    onClick: $setup.onTabClases
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.peopleCircleOutline,
                        "aria-hidden": "true"
                      }, null, 8, ["icon"]),
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Mis Clases")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_ion_tab_button, {
                    layout: "icon-top",
                    tab: "asistencias",
                    href: "/tabs/asistencias",
                    onClick: $setup.onTabAsistencias
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.accessibilityOutline,
                        "aria-hidden": "true"
                      }, null, 8, ["icon"]),
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Asistencias")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_ion_tab_button, {
                    layout: "icon-top",
                    tab: "pagos",
                    href: "/tabs/asientos",
                    onClick: $setup.onTabSaldo
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.walletOutline,
                        "aria-hidden": "true"
                      }, null, 8, ["icon"]),
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Pagos")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }, 512))
            : _createCommentVNode("", true),
          _createVNode(_Transition, { name: "whatsapp-fade" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("button", {
                type: "button",
                class: "btn-whatsapp-ayuda",
                slot: "fixed",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.abrirWhatsappAyuda && $setup.abrirWhatsappAyuda(...args)))
              }, [
                _createVNode(_component_ion_icon, { icon: $setup.logoWhatsapp }, null, 8, ["icon"]),
                _hoisted_1
              ], 512), [
                [_vShow, $setup.estaAutenticado && $setup.showTabBar && $setup.mostrarBotonWhatsappAyuda && !$setup.isMensajesChatView]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }))
}